import { Image, Article } from '../template.state.types';
import { RECEIVED_POSTS_SUCCESSFULLY, LoadMoreAction } from '../loadMore.actions';

export interface AuthorPageSocialLink {
  link: string;
  src: string;
  alt: string;
}

export interface Feed {
  next: string;
  text: string;
}

export interface AuthorPageState {
  image: Image;
  name: string;
  social: { imageLinks: AuthorPageSocialLink[] };
  joinDateText: string;
  joinDate: string;
  articlesNumberText: string;
  totalArticles: number;
  description: string;
  feed: Feed;
  articles: Article[];
}

export type AuthorPageSectionNames = 'articles';

export const authorPageReducer = (state: AuthorPageState = {} as AuthorPageState, action: LoadMoreAction<AuthorPageSectionNames>) => {
  switch (action.type) {
    case RECEIVED_POSTS_SUCCESSFULLY:
      return {
        ...state,
        articles: [
          ...state.articles,
          ...action.articles,
        ],
        feed: {
          ...state.feed,
          next: action.next,
        },
      };

    default:
      return state;
  }
};
